import TopMostPortal from "./ui/utils/Portals";

export interface DuplicateMappingDialogData {
  selectedLineItemId?: string;
  acceptedLineString?: string;
  existingCat?: string;
  existingSel?: string;
  action: "save" | "accept" | "update" | "create";
}

interface DuplicateMappingDialogProps {
  data: DuplicateMappingDialogData;
  onClose: () => void;
}

const ACTION_LABEL: Record<DuplicateMappingDialogData["action"], string> = {
  save: "Save",
  accept: "Accept",
  update: "Update",
  create: "Create",
};

export const DuplicateMappingDialog = ({ data, onClose }: DuplicateMappingDialogProps) => {
  return (
    <TopMostPortal>
      <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50 p-4">
        <div className="bg-white border border-gray-200 rounded-lg max-w-lg w-full shadow-lg">
          <div className="px-5 py-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-900">Duplicate Xactimate Mapping</h2>
            <p className="text-sm text-gray-500 mt-1">
              {ACTION_LABEL[data.action]} aborted — a mapping for this line item with the same accepted line string already exists.
            </p>
          </div>

          <div className="px-5 py-4 space-y-3 text-sm">
            {data.selectedLineItemId && (
              <div>
                <p className="text-gray-500 mb-1">Line item ID</p>
                <code className="font-mono text-gray-900 bg-gray-100 px-1.5 py-0.5 rounded break-all">{data.selectedLineItemId}</code>
              </div>
            )}
            {data.acceptedLineString && (
              <div>
                <p className="text-gray-500 mb-1">Accepted line string</p>
                <code className="font-mono text-gray-900 bg-gray-100 px-1.5 py-0.5 rounded break-all">{data.acceptedLineString}</code>
              </div>
            )}
            {(data.existingCat || data.existingSel) && (
              <div>
                <p className="text-gray-500 mb-1">Existing mapping</p>
                <div className="flex gap-2">
                  {data.existingCat && (
                    <div>
                      <span className="text-xs text-gray-500 mr-1">CAT</span>
                      <code className="font-mono text-gray-900 bg-gray-100 px-1.5 py-0.5 rounded break-all">{data.existingCat}</code>
                    </div>
                  )}
                  {data.existingSel && (
                    <div>
                      <span className="text-xs text-gray-500 mr-1">SEL</span>
                      <code className="font-mono text-gray-900 bg-gray-100 px-1.5 py-0.5 rounded break-all">{data.existingSel}</code>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          <div className="px-5 py-4 border-t border-gray-200 flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium bg-indigo-600 hover:bg-indigo-500 text-white rounded-md transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </TopMostPortal>
  );
};
